import { Flex } from 'antd'
import Image from '@/components/image'
import imageBuild from '@/assets/img/about-us/build.png'
import Styles from './style.module.scss'

const data = [
  'Carus Energy (CARUSG) is an innovative company specializing in the design, development, and cloud services of renewable energy systems for commercial and industrial applications.',
  'Our goal is to provide our clients with reliable, efficient, and cost-effective energy solutions.',
  'We aim to help them reduce energy costs, improve energy efficiency, and promote sustainable business practices Headquartered in San Jose, CA, United States our team was established in 2016, bringing together engineers dedicated to advancing PV and BESS technologies.',
  'With over 500 MWh of installed capacity across tthe U.S., our highly skilled engineers excel in hardware, software, and system-level design, ensuring innovative and reliable energy solutions for commercial and industrial applications.',
]

export default function Info() {
  return (
    <Flex className={Styles.info}>
      <Image src={imageBuild} alt='build' className={Styles.image} />
      <Flex vertical className={Styles.content}>
        {data.map((item, index) => (
          <div key={index} className={Styles.item}>{item}</div>
        ))}
      </Flex>
    </Flex>
  )
}
